import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { RegisterService } from '../proxy/planning/controllers/register.service';

FieldBuilder.setNamespace('Planning');

export const REGISTERAREA_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .date('date', 'Entity.RegisterArea.Date')
    .required()
    .build(),
  FieldBuilder
    .text('generalNumber', 'Entity.RegisterArea.GeneralNumber')
    .maxLength(30)
    .build(),
  FieldBuilder
    .number('generalArea', 'Entity.RegisterArea.GeneralArea')
    .required()
    .decimal(4, 10)
    .build(),
  FieldBuilder
    .text('productivityNumber', 'Entity.RegisterArea.ProductivityNumber')
    .maxLength(30)
    .build(),
  FieldBuilder
    .number('productivityArea', 'Entity.RegisterArea.ProductivityArea')
    .required()
    .decimal(4, 10)
    .build(),
  FieldBuilder
    .text('nativeNumber', 'Entity.RegisterArea.NativeNumber')
    .maxLength(30)
    .build(),
  FieldBuilder
    .number('nativeArea', 'Entity.RegisterArea.NativeArea')
    .required()
    .decimal(4, 10)
    .build(),
  FieldBuilder
    .text('protectorNumber', 'Entity.RegisterArea.ProtectorNumber')
    .maxLength(30)
    .build(),
  FieldBuilder
    .number('protectorArea', 'Entity.RegisterArea.ProtectorArea')
    .required()
    .decimal(4, 10)
    .build(),
  FieldBuilder
    .text('woodQualityNumber', 'Entity.RegisterArea.WoodQualityNumber')
    .maxLength(30)
    .build(),
  FieldBuilder
    .number('woodQualityArea', 'Entity.RegisterArea.WoodQualityArea')
    .required()
    .decimal(4, 10)
    .build(),
  FieldBuilder
    .text('notes', 'Entity.RegisterArea.Notes')
    .maxLength(200)
    .build(),
  FieldBuilder
    .text('plantationDate', 'Entity.RegisterArea.PlantationDate')
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('planNumber', 'Entity.RegisterArea.PlanNumber')
    .maxLength(50)
    .build(),
  FieldBuilder.foreignKey(
    'registerId',
    'Entity.Register',
    RegisterService
  )
    .required()
    .displayFromNested('register.name')
    .sortBy('register.name')
    .build(),
];

export const REGISTERAREA_CONFIG = {
  entityName: 'RegisterArea',
  localizationKey: 'Planning::Entity.RegisterArea',
  fields: REGISTERAREA_FIELDS,
  permission: 'PlanningLocation.RegisterAreas',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
};
